document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(function() {
    const activeThumb = document.querySelector('.slider-counter__link--active');
    if (!activeThumb) return;
    activeThumb.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'nearest', 
      inline: 'center' 
    });
  });

  const thumbList = document.querySelector('.thumbnail-list');
  if (thumbList) {
    observer.observe(thumbList, { 
      attributes: true, 
      subtree: true, 
      attributeFilter: ['class', 'aria-current'] 
    });
  }
});